export { default } from './customer-support-drawer.component';
